<template>
  <div>
    <div class="carousel-wrapper">
      <!-- Chevron Left Carousel -->
      <div
        v-if="ShowCustomCarouselControls"
        class="left-button mr-2"
        @click="goToPrev"
        :style="currentIndex > 0 ? '' : 'visibility:hidden'"
      >
        <v-icon class="text-accelerate-grey-2">mdi-chevron-left</v-icon>
      </div>

      <!-- Carousel Item -->
      <v-carousel
        v-model="currentIndex"
        height="auto"
        :cycle="false"
        hide-delimiters
        hide-delimiter-background
        :show-arrows="false"
        style="box-shadow: none"
      >
        <v-carousel-item v-for="(slotName, index) in slotNames" :key="index" class="carousel-item">
          <slot :name="slotName" />
        </v-carousel-item>
      </v-carousel>

      <!-- Custom Right Carousel -->
      <div
        v-if="ShowCustomCarouselControls"
        class="right-button ml-2"
        @click="goToNext"
        :style="currentIndex < slotNames.length - 1 ? '' : 'visibility:hidden'"
      >
        <v-icon class="text-accelerate-grey-2">mdi-chevron-right</v-icon>
      </div>
    </div>

    <!-- Custom Delimiters -->
    <div v-if="ShowCustomDelimiters" class="mt-2 center-delimiter">
      <v-btn
        v-for="(slotName, index) in slotNames"
        :key="index"
        small
        class="dot-btn mx-0"
        :class="currentIndex === index ? 'dot-active' : ''"
        @click="goToIndex(index)"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    ShowCustomCarouselControls: {
      type: Boolean,
      default: true
    },
    ShowCustomDelimiters: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currentIndex: 0
    };
  },

  computed: {
    slotNames() {
      return Object.keys(this.$slots).filter((slot) => slot !== 'default');
    }
  },

  methods: {
    goToPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
    goToNext() {
      if (this.currentIndex < this.slotNames.length - 1) {
        this.currentIndex += 1;
      }
    },
    goToIndex(index) {
      this.currentIndex = index;
    }
  }
});
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.left-button,
.right-button {
  position: relative;
  cursor: pointer;
}

.center-delimiter {
  display: flex;
  justify-self: center;
}

.dot-btn {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #bfbfbf !important;
  box-shadow: none !important;
  border: none;
  padding: 0;
  min-width: 10px !important;
  min-height: 10px !important;
  max-width: 10px !important;
  max-height: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px !important;
}

.dot-active {
  background-color: #000000 !important;
}
</style>
